import { render, staticRenderFns } from "./CSalesRmAlias.vue?vue&type=template&id=b7ebd2c2"
import script from "./CSalesRmAlias.vue?vue&type=script&lang=ts"
export * from "./CSalesRmAlias.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VRow})
